import { SlimUser } from '../Api/Kopp/Api';
import _, { random } from 'lodash';
import React from 'react';
import { AuthUser } from 'Core/models/AuthUser';
import moment, { Moment } from 'moment';
import ConfigUtility from 'Core/ConfigUtility';
import { ErrorResultModel } from 'Core/Api/UserManagement/Api';
import AppRoute from 'Core/models/AppRoute';
import TokenUtility from 'Core/TokenUtility';
import { matchPath } from 'react-router-dom';

export default class Utility {

  public static enumToSelectionOptionArray(enumeration: any): { text: string; value: any }[] {
    const list: { text: string; value: any }[] = [];
    this.enumToMap(enumeration).forEach((x, y) => list.push({ text: x, value: y }));
    return list;
  }

  public static enumToMap(enumeration: any): Map<any, any | any> {
    const map = new Map<string, string | number>();
    for (let key in enumeration) {
      //TypeScript does not allow enum keys to be numeric
      if (!isNaN(Number(key))) continue;

      const val = enumeration[key] as string | number;

      //TypeScript does not allow enum value to be null or undefined
      if (val !== undefined && val !== null) map.set(key, val);
    }
    return map;
  }


  static BuildErrorListItems(modelState: { [key: string]: string[] } | undefined) {
    let messages: string[] = [];
    // Get messages from modelState
    for (const key in modelState) {
      if (modelState.hasOwnProperty(key)) {
        const messageList = modelState[key];
        if (messageList.length > 0) messages.push(messageList[0]);
      }
    }

    // Create a list React Node for display
    return (
      <ul>
        {messages.map(x => (
          <li>{x} </li>
        ))}
      </ul>
    );
  }

  static voidmethod(): void {

  }

  public static formatError<T = any>(reason: any, genericMessage?: string) {

    if (reason?.response) {

      if (reason?.response?.ModelState) {
        const messageNode = Utility.BuildErrorListItems(reason.response.ModelState);
        throw messageNode;
      }

      if (reason?.response?.status >= 400 && reason?.response?.status < 500) {
        if (reason.response.data) {

          if (reason.response.data.Errors) {
            const messageNode = Utility.BuildErrorListItems(reason.response.data.Errors);
            throw messageNode;
          }

          if (reason.response.Errors) {
            const messageNode = Utility.BuildErrorListItems(reason.response.data.Errors);
            throw messageNode;
          }

          if (reason.response.data?.ErrorMessage) {
            throw reason.response.data?.ErrorMessage;
          }

          if (reason.response.data?.message) {
            throw reason.response.data?.message;
          }

          const errorResponse = ErrorResultModel.fromJS(reason.response.data) as ErrorResultModel;
          errorResponse.modelSate = reason.response.data.ModelState;
          const messageNode = Utility.BuildErrorListItems(errorResponse.modelSate);
          throw messageNode;
        }
        else if (reason.errorMessage) {
          throw Error(reason.errorMessage);
        }
        else {
          console.log(reason);
          throw genericMessage || "An error occured while handling operation. If problem persists please contact the administrator.";
        }
      }
    } else if (reason?.ErrorMessage) {
      throw reason.ErrorMessage;
    } else {
      console.log(reason);
      throw genericMessage || " An error occured while handling operation. If problem persists please contact the administrator.";
    }
    return {} as T;
  }

  public static isPathOrSubpathAMatch(path: string, match: AppRoute): boolean {
    return (
      !!matchPath(path, match) ||
      (match.routes?.some(x => Utility.isPathOrSubpathAMatch(path, x)) ?? false)
    );
  }

  public static isSubPathVisible(match: AppRoute): boolean {
    return (
      !match.hideInMainMenu ||
      (match.routes?.some(x => Utility.isSubPathVisible(x)) ?? false)
    );
  }

  public static getAppRoutesWithFullPath(AppRoutes?: AppRoute[], parentPath: string = ''): AppRoute[] | undefined {
    return AppRoutes?.map(x => {
      const fullPath = Utility.combinePath(parentPath, x.path as string);
      return { ...x, path: fullPath, routes: Utility.getAppRoutesWithFullPath(x.routes, fullPath) }
    });
  }

  public static combinePath(...args: string[]) {
    let path = args[0];

    if (!args[0]) {
      return args[1] || args[0];
    }

    return (
      args
        .reduce((previousPath: string, nextpath: string) => {
          return nextpath.indexOf('/') === 0 && nextpath === '/'
            ? previousPath
            : previousPath + '/' + nextpath;
        }, '')
        // this is not an ideal solutions but it should work for now
        .replace('//', '/')
    );
  }

  public static HasOperations(user: AuthUser, requiredOperations: string[]) {
    // if no operations are supplied, it is a public page
    if (!requiredOperations || requiredOperations.length === 0) {
      return true;
    }

    // if operations are supplied and the user is not logged in, they need to login
    if ((user === null || user === undefined) && requiredOperations.length > 0) {
      return false;
    }

    // search through all required operations to see if the user has all of them

    for (const requiredOperation of requiredOperations) {
      if (user && user.operations && user.operations.length > 0) {
        const foundOperation = user.operations.filter(x => x.toString() === requiredOperation);

        // an operation that was required was not in the users list, they don't have permission
        if (!foundOperation || foundOperation.length === 0) {
          return false;
        }
      } else {
        // the user has no operations so it must be that the need permission
        return false;
      }
    }

    // to reach this point means that all operations needed where found in the users operations
    return true;
  }

  public static RandomNumber(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  public static ToDateString(date: Moment): string {
    const config = ConfigUtility.getSync();
    if ((date as Moment).format != undefined) {
      return (date as Moment).format(config?.Display.DateFormat);
    } else {
      return moment(date).format(config?.Display.DateFormat);
    }
  }

  public static ConvertToStandardTimezone(date: Moment) {
    const config = ConfigUtility.getSync();
    return moment.parseZone(date.utcOffset(config?.Display.StandardTimeZone ?? -5).format("YYYY-MM-DDTHH:mm:ss.sss") + config?.Display.StandardTimeZoneString ?? "-05:00");
  }

  public static getDisableBOLDates() {
    const config = ConfigUtility.getSync();
    if ((moment().utcOffset() / 60) > config!.Display!.StandardTimeZone) {
      return (current) => current ? (current && current < moment().add(-1, "day")) : (false);
    } else {
      return (current) => current ? (current && current < moment().add(-1, "day")) : (false);
    }
  }

  public static ToDateTimeString(date: Moment | string): string {
    const config = ConfigUtility.getSync();
    if ((date as Moment).format != undefined) {
      return (date as Moment).format(config?.Display.DateTimeFormat);
    } else {
      return moment(date).format(config?.Display.DateTimeFormat);
    }
  }

  public static ToTimeString(date: Moment | string): string {
    const config = ConfigUtility.getSync();
    if ((date as Moment).format != undefined) {
      return (date as Moment).format(config?.Display.TimeFormat);
    } else {
      return moment(date).format(config?.Display.TimeFormat);
    }
  }

  public static ContactTel(): string {
    const config = ConfigUtility.getSync();
    const telephone = config?.Contact?.Telephone;
    return !telephone ? "" : telephone;
  }
  public static ContactEmail(): string {
    const config = ConfigUtility.getSync();
    const email = config?.Contact?.Email;
    return !email ? "" : email;
  }
  public static ContactFax(): string {
    const config = ConfigUtility.getSync();
    const fax = config?.Contact?.Fax;
    return !fax ? "" : fax;
  }

  public static ReCaptureSiteKey(): string {
    const config = ConfigUtility.getSync();
    const siteKey = config?.ReCaptcha.siteKey;
    return !siteKey ? "" : siteKey;
  }

  /**
   * https://gist.github.com/nicbell/6081098#file-object-compare-js
   *
   * @static
   * @param {*} obj1
   * @param {*} obj2
   * @returns
   * @memberof Utility
   */
  public static Compare(obj1, obj2) {
    return _.isEqual(obj1, obj2);
    // Loop through properties in object 1
    // tslint:disable-next-line:forin
  }

  public static myCompare(obj1, obj2) {
    // tslint:disable-next-line:forin prefer-const 
    for (let p in obj1) {
      // Check property exists on both objects
      if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
        return false;
      }

      switch (typeof obj1[p]) {
        // Deep compare objects
        case 'object':
          if (!Utility.Compare(obj1[p], obj2[p])) {
            return false;
          }
          break;
        // Compare function code
        case 'function':
          if (
            // tslint:disable-next-line:triple-equals
            typeof obj2[p] === 'undefined' ||
            // tslint:disable-next-line:triple-equals
            // eslint-disable-next-line eqeqeq
            (p != 'compare' && obj1[p].toString() != obj2[p].toString())
          ) {
            return false;
          }
          break;
        // Compare values
        default:
          // tslint:disable-next-line:triple-equals
          if (obj1[p] !== obj2[p]) {
            return false;
          }
      }
    }

    // Check object 2 for any extra properties
    // tslint:disable-next-line:prefer-const
    for (let p in obj2) {
      if (!obj2.hasOwnProperty(p)) {
        continue;
      }
      if (!obj1.hasOwnProperty(p)) {
        return false;
      }
    }
    return true;
  }


  public static retry<A>(fn: Promise<A>, retriesLeft = 5, intervalMs = 1000): Promise<A> {
    return new Promise((resolve, reject) => {
      fn
        .then(resolve)
        .catch((error) => {
          setTimeout(() => {
            if (retriesLeft === 1) {
              // reject('maximum retries exceeded');
              reject(error);
              return;
            }

            // Passing on "reject" is the important part
            Utility.retry(fn, intervalMs, retriesLeft - 1).then(resolve, reject);
          }, intervalMs);
        });
    });
  }

  static GetOrGenerateCorrleationId(): any {
    return Utility.newGuid();
  }


  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  constructor() { }
}
